import { DrawerContent } from '@/components/drawer-content';
import { Drawer } from 'expo-router/drawer';

export default function DrawerLayout() {
  return (
    <Drawer initialRouteName="(core)" drawerContent={() => <DrawerContent />}>
      <Drawer.Screen
        name="(core)"
        options={{
          drawerType: 'front',
          swipeEnabled: true,
          drawerPosition: 'left',
          headerShown: false
        }}
      />
    </Drawer>
  );
}
